import React from 'react';

import { OutlinedInput, FormHelperText } from '@mui/material';
import { useTranslation } from 'next-i18next';
import InputMask from 'react-input-mask';

import theme from 'src/theme';

interface CustomProps {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
}

const MaskedCitizenIdInput = React.forwardRef<HTMLInputElement, CustomProps>((props, ref) => {
  const { onChange, ...other } = props;

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;
    event.target.value = value.replace(/-/g, '').trim();
    onChange(event);
  };

  return (
    <InputMask
      {...other}
      mask="9-9999-99999-99-9"
      inputRef={ref}
      onChange={onInputChange}
      alwaysShowMask={false}
      maskPlaceholder={null}
    />
  );
});

const citizenIdCharacterLength = 13;

export const CitizenIdInput = ({
  citizenId,
  citizenIdValidationResult,
  setIsValidCitizenId,
  setCitizenId,
  setCitizenIdValidationResult,
  fullWidth = false,
  validateCitizenId,
}: any) => {
  const { t } = useTranslation();

  const handleCitizenIdInput = ({ target }: any) => {
    const { value } = target;

    const validationResult = validateCitizenId(value);
    setCitizenIdValidationResult(validationResult);
    setCitizenId(value);
    setIsValidCitizenId(value.length === citizenIdCharacterLength && !validationResult.isError);
  };

  return (
    <>
      <OutlinedInput
        sx={{ fontSize: '18px' }}
        fullWidth={fullWidth}
        placeholder={t('cpd_course.fill_citizen_id_placeholder')}
        size="small"
        value={citizenId}
        error={citizenIdValidationResult.isError}
        onChange={handleCitizenIdInput}
        inputComponent={MaskedCitizenIdInput as any}
      />
      {citizenIdValidationResult.isError && (
        <FormHelperText
          sx={{ color: theme.palette.errorDark.main, mt: '-2px', fontSize: '18px', position: 'absolute' }}
        >
          {citizenIdValidationResult.message}
        </FormHelperText>
      )}
    </>
  );
};

export default MaskedCitizenIdInput;
